import {
  Component,
  DoCheck,
  EventEmitter,
  Input,
  KeyValueDiffer,
  KeyValueDiffers,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PastExamsDataService } from './past-exams-data';

const range = (start: number, end: number) =>
  Array.from({ length: end - start }, (v, k) => k + start);

export class Model {
  isPastExam = false;
  day?: number;
  month?: number;
  year?: number;
  from?: string; // Exam
  school?: string;
  grade?: string;
  paper?: string;
  question_number?: string;
  exam?: string; // School exam type
  booklet?: string;
  timezone?: string;
  session?: string;
  set?: string;
  series?: string;
}

@Component({
  selector: 'app-past-exams',
  templateUrl: './past-exams.component.html',
  styleUrls: ['./past-exams.component.css'],
})
export class PastExamsComponent implements DoCheck {
  @Output() changed = new EventEmitter<Model>();
  @Input() model!: Model;

  originalModel = new Model();

  day = 0;
  month = 0;
  year = 0;
  years = range(1970, new Date().getFullYear() + 1).sort((a, b) => (a < b ? 1 : -1));
  monthNames: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  months: { index: number; name: string }[] = [];
  days = range(1, 32);
  exams = [
    { name: this.translate.instant('School Exam'), exam: 'School' },
    { name: this.translate.instant('Singapore GCE O-Level'), exam: 'GCE O-Level' },
    { name: this.translate.instant('Singapore GCE A-Level'), exam: 'GCE A-Level' },
    { name: this.translate.instant('NEET'), exam: 'NEET' },
    { name: this.translate.instant('IB Exam'), exam: 'IB Exam' },
    { name: this.translate.instant('PSLE'), exam: 'PSLE' },
    { name: this.translate.instant('IGCSE'), exam: 'IGCSE' },
    { name: this.translate.instant('IIT-JEE Main'), exam: 'IIT-JEE Main' },
    { name: this.translate.instant('UPSC IAS Prelims'), exam: 'UPSC IAS Prelims' },
    { name: this.translate.instant('CBSE'), exam: 'CBSE' },
    {
      name: this.translate.instant('Royal College Physician Licensing Exam'),
      exam: 'Royal College Physician Licensing Exam',
    },
  ];

  schools: string[] = this.pastExamsDataService.schools.sort();

  schoolExamType = this.pastExamsDataService.sortExamDataByValue(
    this.pastExamsDataService.examTypes,
  );
  schoolGrades = this.pastExamsDataService.sortExamDataByValue(this.pastExamsDataService.grades);
  school = '';
  papers = this.pastExamsDataService.papers;
  ibTimezone = [
    { name: this.translate.instant('Timezone 0'), tz: '0' },
    { name: this.translate.instant('Timezone 1'), tz: '1' },
    { name: this.translate.instant('Timezone 2'), tz: '2' },
  ];
  psleBooklet = [
    { name: this.translate.instant('Booklet A'), booklet: 'A' },
    { name: this.translate.instant('Booklet B'), booklet: 'B' },
  ];
  iitJeeSession = [
    { name: this.translate.instant('Morning Session'), session: 'morning' },
    { name: this.translate.instant('Afternoon Session'), session: 'afternoon' },
  ];
  upscIasPrelimsPapers = [
    { name: this.translate.instant('Paper 1: General Studies (GS)'), paper: '1' },
    { name: this.translate.instant('Paper 2: Civil Services Aptitude Test (CSAT)'), paper: '2' },
  ];
  upscIasPrelimsBooklet = [
    { name: this.translate.instant('Booklet A'), booklet: 'A' },
    { name: this.translate.instant('Booklet B'), booklet: 'B' },
    { name: this.translate.instant('Booklet C'), booklet: 'C' },
    { name: this.translate.instant('Booklet D'), booklet: 'D' },
  ];
  royalCollegeExamPapers = [
    { name: this.translate.instant('Paper 1 (MCQ)'), paper: '1' },
    { name: this.translate.instant('Paper 2 (SAQ)'), paper: '2' },
  ];
  differ: KeyValueDiffer<string, any>;

  constructor(
    private differs: KeyValueDiffers,
    private pastExamsDataService: PastExamsDataService,
    private translate: TranslateService,
  ) {
    this.differ = this.differs.find({}).create();
    // TODO: check if necessary or can hard code ////////
    this.monthNames.forEach((month: string, i: number) => {
      this.months.push({ index: i, name: month });
      // ///////////////////////////////////////////////////
    });
  }

  ngDoCheck(): void {
    if (!this.differ) {
      return;
    }
    const change = this.differ.diff(this.model);
    if (change) {
      this.changed.emit(this.model);
    }
  }
}
